import axios from "axios";

class BovedaApi {
  constructor(apiUrl) {
    this.apiUrl = apiUrl;
  }

  async bovedaApiLogin(email, password) {
    email = email.toLowerCase()

    let response = await axios.post(`${this.apiUrl}/login-boveda-api`, {
      email,
      password,
    });
    return response.data;
  }

  async updateUserDocsPi(email, name, paternaLastName, maternaLastName, token) {
    email = email.toLowerCase()

    let data = {
      email: email,
      name: name,
      paternaLastName: paternaLastName,
      maternaLastName: maternaLastName,
    };
    let config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await axios.post(
      `${this.apiUrl}/update-colab-user-docs`,
      data,
      config
    );
    return response;
  }

  async getBovedaDocument(signRequestId, token) {
    const response = await axios.get(`${this.apiUrl}/upload-boveda?signResquestId=${signRequestId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`
        }
      })
    return response.data.data
  }

  async uploadBovedaDocument(signRequestId, token) {
    const response = await axios.post(`${this.apiUrl}/upload-boveda`, {
      signResquestId: signRequestId
    },
      {
        headers: {
          Authorization: `Bearer ${token}`
        }
      })
    return response.data.data
  }
}

export { BovedaApi as default };
